import { Action } from '@ngrx/store';

export const SET_MY_SHOP_NAME = '[MyShop] Set My Shop Name';
export const INIT_MY_SHOP = '[MyShop] Init My Shop';

export class SetMyShopName implements Action {
  readonly type = SET_MY_SHOP_NAME;

  constructor(public name: string) {}
}

export class InitMyShop implements Action {
  readonly type = INIT_MY_SHOP;
}

export type MyShopPointOfServiceAction = SetMyShopName | InitMyShop;
